export const Header = ({ children }) => {
  return <h1 className="product-title">{children}</h1>;
};
